import { InjectionToken } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ProductFetchParams } from '@floori/models';
import { HashMap } from '@floori-web-components';
import { NavigationOptions } from './navigation-options';
import {
    ArDialogAction,
    ArModelUrls,
} from '@floori-web/ar/ui/floori-ar-dialog/src/lib/floori-ar-dialog-data';

export const FLOORI_NAVIGATION = new InjectionToken('FLOORI_NAVIGATION');

export interface NavigationProvider {
    appendQueryParam(paramName: string, value: string | null): void;

    appendQueryParams(params: Array<{ name: string; value: string | null }>): void;

    dynamicProductParams(): [string, string, string] | null;

    goToRoom(routeParams: HashMap<string>, queryParams?: HttpParams): Promise<boolean>;

    goToRooms(): Promise<boolean>;

    getArLink(
        params: ProductFetchParams,
        action?: ArDialogAction,
        arModelUrls?: ArModelUrls,
    ): string;

    goToAr(params: ProductFetchParams, target?: string): Promise<string>;

    goToContact(link: string): void;

    goToBookDemo(link: string, lang: string): void;

    goToUrl(link: string, options?: NavigationOptions): void;

    getUrl(): string;
}
